// Mirror of C# enum Connect.Contracts.ConnectPlatform — keep in sync.
// Enum values are also used to build queue names on the backend; do not rename without
// updating the dependent (convention-based) items.
export const ConnectPlatform = {
    Yuki: 2,
    // 3 was removed (dropbox)
    ExactOnline: 6,
    Pom: 7,
    Octopus: 8,
    Horus: 9,
    Connective: 10,
    Office365: 11,
    OkSign: 12,
    CodaBox: 13,
    AdobeSign: 14,
    Winbooks: 15,
    Billit: 16,
    Clearfacts: 17,
    Estox: 18,
    SageCloudDemat: 19,
    Gmail: 20,
    // 21 was removed
    TypeForm: 22,
    Penneo: 23,
    DocuSign: 24,
    Billtobox: 25,
    CompanyWeb: 26,
    Twikey: 27,
    Mollie: 28,
    Flowin: 29,
    Minox: 30,
    Sharepoint: 31,
    FiscaalGemak: 32,
    eBoekhouden: 33,
    ValidSign: 34,
    OutlookContacts: 35,
    MyMinFin: 36,
    Grub: 37,
    Dapas: 38,
    PKIsigning: 39,
    Nmbrs: 40,
    // 41 was removed (companyinfo)
    OpenTheBox: 42,
    Mailblue: 43,
    Ponto: 44,
    HIX: 45,
    O365Editor: 46,
    Odoo: 47,
    CodaClean: 48,
    IonBiz: 49,
    VisionPlanner: 50,
    HIXSign: 51,
    SharepointAutoSync: 52,
    Nextens: 53,
    TwinnTax: 54,
    OutlookCalendar: 55,
    MyCodaBox: 56,
    // 57 was removed (docubird)
    Liantis: 58,
    YukiRest: 59,
    Caseware: 60,
};
